import { ApplicationApiTagTypes } from "@/modules/application/common/enum";
import { applicationApi } from "@/modules/application/services";
import { useAppDispatch } from "@/shared/hooks";
import type { Dispatch, SetStateAction } from "react";

import { DeleteApplicationModal } from "./DeleteApplicationModal";
import { SendToEditModal } from "./SendToEditModal";

interface Props {
  onClose?: () => void;
  isOpenSendToEdit: boolean;
  isDeleteModalOpen: boolean;
  applicationId?: string;
  applicationType?: string;
  setIsOpenSendToEdit: Dispatch<SetStateAction<boolean>>;
  setIsDeleteModalOpen: Dispatch<SetStateAction<boolean>>;
}

export const ApplicationActionModals = ({
  onClose = () => {},
  applicationId,
  applicationType = "",
  isOpenSendToEdit,
  setIsOpenSendToEdit,
  isDeleteModalOpen,
  setIsDeleteModalOpen,
}: Props) => {
  const dispatch = useAppDispatch();
  const refetch = () => {
    dispatch(applicationApi.util.invalidateTags([ApplicationApiTagTypes.ApplicationHistory]));
    onClose();
  };

  return (
    <>
      {applicationId && (
        <SendToEditModal
          onConfirm={refetch}
          onClose={() => setIsOpenSendToEdit(false)}
          applicationId={applicationId}
          applicationType={applicationType}
          isOpen={isOpenSendToEdit}
        />
      )}
      <DeleteApplicationModal
        refetch={refetch}
        isDeleteModalOpen={isDeleteModalOpen}
        setIsDeleteModalOpen={setIsDeleteModalOpen}
      />
    </>
  );
};
